import { createGlobalState } from '@vueuse/core';
import { ref, nextTick } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { HTTP_INTERNAL_SERVER_ERROR, HTTP_NOT_FOUND } from '~/support/HttpStatuses';
import { adminUsersClient } from '~/services';

export const useUserDetails = createGlobalState(() => {
    const toasted = useToasted();

    const user = ref({});
    const loading = ref(true);

    const catchRequestError = (error) => {
        console.error(error);
        if (
            !error?.response?.status ||
            error?.response?.status >= HTTP_INTERNAL_SERVER_ERROR ||
            error?.response.status == HTTP_NOT_FOUND
        ) {
            toasted?.global.platform_error();
        } else {
            toasted?.error(error.response?.data?.message || 'Something went wrong.');
        }
    };

    let onMountedUserCallback = () => {};
    const onMountedUser = (callback) => {
        onMountedUserCallback = callback;
    };

    const mount = async (userId) => {
        await nextTick();

        if (!userId) {
            user.value = {};
            loading.value = false;
            onMountedUserCallback?.();
            return;
        }

        try {
            loading.value = true;

            const response = await adminUsersClient.showUser(userId);
            user.value = response.data;
            loading.value = false;
            onMountedUserCallback?.();
        } catch (e) {
            catchRequestError(e);
        }
    };

    const unmount = () => {
        user.value = {};
        loading.value = false;
    };

    return {
        loading,
        user,
        mount,
        unmount,
        onMountedUser,
    };
});
